import React, { Fragment } from 'react'
import { H3 } from '@blueprintjs/core'

const ImageCardWithAttributesResume = ({ index, attributes, totalAttibutes, ressourcesLength }) => (
    <div className='text-center margin-top-large new-results attributes-results-card-resume'>
        <H3 className='new-results margin-bottom-medium' >Sequence summary - Sequence {index}</H3>
        {attributes.map((at, i) =>
            <Fragment key={i}>
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>{attributes[i].name}:</div>
                    <div> {totalAttibutes[i]
                        ?
                        (attributes[i].unit === "%")
                            ?
                            (totalAttibutes[i] / ressourcesLength).toFixed(2)
                            :
                            totalAttibutes[i].toFixed(2)
                        : ""
                    } {attributes[i].unit}
                    </div>
                </div>
                {(i < attributes.length - 1) && (<hr />)}
            </Fragment>
        )}
    </div>
)

export default ImageCardWithAttributesResume
